/* Vice City — global behavior. Cart engine ported from the Earth Revibe theme
   (Shopify AJAX + Section Rendering API); drop countdown and option-pill
   variant resolution are new. */
(function () {
  'use strict';

  var VC = (window.VC = window.VC || {});

  /* ---------- scroll lock ---------- */
  VC.lock = function () {
    document.documentElement.classList.add('vc-lock');
  };
  VC.unlock = function () {
    document.documentElement.classList.remove('vc-lock');
  };

  /* ---------- drawers ---------- */
  function openDrawer(root) {
    if (!root) return;
    root.hidden = false;
    VC.lock();
  }
  function closeDrawer(root) {
    if (!root) return;
    root.hidden = true;
    VC.unlock();
  }
  VC.openCart = function () {
    openDrawer(document.getElementById('vc-cart'));
  };
  VC.closeCart = function () {
    closeDrawer(document.getElementById('vc-cart'));
  };

  /* ---------- cart engine (AJAX + Section Rendering) ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.setAttribute('data-count', String(count));
    });
  }

  function swapCartSection(html) {
    var wrapper = document.getElementById('shopify-section-cart-drawer');
    if (!wrapper || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-cart-drawer');
    var root = document.getElementById('vc-cart');
    var wasOpen = root && !root.hidden;
    if (fresh) wrapper.innerHTML = fresh.innerHTML;
    if (wasOpen) {
      root = document.getElementById('vc-cart');
      if (root) root.hidden = false;
    }
  }

  VC.refreshCart = function () {
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        swapCartSection(data['cart-drawer']);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
      })
      .catch(function () {});
  };

  function cartChange(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: '/',
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (cart.sections) swapCartSection(cart.sections['cart-drawer']);
      })
      .catch(function () {});
  }

  VC.addToCart = function (id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: quantity || 1 }],
        sections: 'cart-drawer',
        sections_url: '/',
      }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (res) {
        if (res.sections) swapCartSection(res.sections['cart-drawer']);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
        VC.openCart();
        return cart;
      });
  };

  /* ---------- drop countdown ----------
     [data-countdown data-deadline="ISO"] hides itself and reveals
     [data-drop-live] (same section scope) when the deadline passes. */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el.dataset.init) return;
      el.dataset.init = '1';
      var deadline = Date.parse(el.getAttribute('data-deadline') || '');
      if (isNaN(deadline)) return;
      var scope = el.closest('[data-drop-scope]') || document;
      var liveEls = scope.querySelectorAll('[data-drop-live]');
      var waitEls = scope.querySelectorAll('[data-drop-wait]');
      var nums = {
        d: el.querySelector('[data-cd-d]'),
        h: el.querySelector('[data-cd-h]'),
        m: el.querySelector('[data-cd-m]'),
        s: el.querySelector('[data-cd-s]'),
      };
      var timer = null;

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }
      function render() {
        var left = deadline - Date.now();
        if (left <= 0) {
          if (timer) clearInterval(timer);
          waitEls.forEach(function (w) { w.hidden = true; });
          liveEls.forEach(function (l) { l.hidden = false; });
          return;
        }
        var s = Math.floor(left / 1000);
        if (nums.d) nums.d.textContent = pad(Math.floor(s / 86400));
        if (nums.h) nums.h.textContent = pad(Math.floor((s % 86400) / 3600));
        if (nums.m) nums.m.textContent = pad(Math.floor((s % 3600) / 60));
        if (nums.s) nums.s.textContent = pad(s % 60);
      }
      if (deadline - Date.now() <= 0) {
        render();
        return;
      }
      liveEls.forEach(function (l) { l.hidden = true; });
      waitEls.forEach(function (w) { w.hidden = false; });
      render();
      timer = setInterval(render, 1000);
    });
  }

  /* ---------- PDP: option pills -> variant resolution ---------- */
  function initPdp() {
    var root = document.querySelector('[data-vc-pdp]');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var variants = [];
    var dataEl = root.querySelector('[data-variant-json]');
    try {
      variants = JSON.parse(dataEl ? dataEl.textContent : '[]');
    } catch (e) {
      variants = [];
    }

    var groups = root.querySelectorAll('[data-opt-group]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var low = root.querySelector('[data-pdp-lowstock]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var buyBtn = root.querySelector('[data-pdp-buy]');
    var current = null;

    // Single-variant products render no pill groups — resolve directly.
    if (!groups.length && variants.length) {
      current = variants.find(function (v) { return v.available; }) || variants[0];
    }

    function selectedOptions() {
      var opts = [];
      groups.forEach(function (g) {
        var on = g.querySelector('.vc-pill.is-selected');
        opts[Number(g.getAttribute('data-opt-group'))] = on
          ? on.getAttribute('data-value')
          : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          return opts[i] === null || opts[i] === val;
        });
      });
    }

    function matchExact(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return opts[i] === val; });
      });
    }

    function sync() {
      if (groups.length) {
        var opts = selectedOptions();
        if (opts.some(function (o) { return o === null; })) return;
        current = matchExact(opts) || null;

        // pill availability per group, holding other selections fixed
        groups.forEach(function (g) {
          var gi = Number(g.getAttribute('data-opt-group'));
          g.querySelectorAll('.vc-pill').forEach(function (pill) {
            var probe = opts.slice();
            probe[gi] = pill.getAttribute('data-value');
            var v = matchExact(probe);
            pill.classList.toggle('is-oos', !v || !v.available);
          });
        });
      }

      var available = current && current.available;
      if (priceEl && current) priceEl.textContent = current.price_formatted;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute('data-label-add') : 'SOLD OUT';
      }
      if (buyBtn) buyBtn.disabled = !available;
      if (low) {
        var q = current ? current.stock : -1;
        if (available && q > 0 && q <= 5) {
          low.hidden = false;
          low.textContent = 'Only ' + q + ' left in the run';
        } else {
          low.hidden = true;
        }
      }
    }

    groups.forEach(function (g) {
      g.querySelectorAll('.vc-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          g.querySelectorAll('.vc-pill').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          pill.classList.add('is-selected');
          sync();
        });
      });
    });

    // mobile gallery dots
    var scroller = root.querySelector('[data-pdp-scroller]');
    var dots = root.querySelectorAll('[data-pdp-dots] span');
    if (scroller && dots.length > 1) {
      scroller.addEventListener('scroll', function () {
        var w = scroller.offsetWidth;
        if (!w) return;
        var idx = Math.round(scroller.scrollLeft / w);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!current || !current.available) return;
        addBtn.disabled = true;
        VC.addToCart(current.id, 1)
          .catch(function () {})
          .then(function () { addBtn.disabled = false; });
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (!current || !current.available) return;
        buyBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(current.id), quantity: 1 }] }),
        })
          .then(function () {
            // Same guard as Earth Revibe: if Razorpay Magic Checkout is ever
            // embedded, hand it the cart page instead of a hard navigation.
            window.location.href = window.__init_magic_x__
              ? '/cart?magicx_open=true'
              : '/checkout';
          })
          .catch(function () { buyBtn.disabled = false; });
      });
    }

    sync();
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = function (sel) { return e.target.closest(sel); };

    if (t('[data-menu-open]')) {
      openDrawer(document.getElementById('vc-menu'));
    } else if (t('[data-menu-close]')) {
      closeDrawer(document.getElementById('vc-menu'));
    } else if (t('[data-cart-open]')) {
      e.preventDefault();
      VC.openCart();
    } else if (t('[data-cart-close]')) {
      VC.closeCart();
    } else if (t('[data-cart-plus]')) {
      var el = t('[data-cart-plus]');
      var reload1 = !!el.closest('[data-cart-reload]');
      cartChange(Number(el.getAttribute('data-line')), Number(el.getAttribute('data-qty')) + 1).then(function () {
        if (reload1) window.location.reload();
      });
    } else if (t('[data-cart-minus]')) {
      var el2 = t('[data-cart-minus]');
      var q = Number(el2.getAttribute('data-qty'));
      var reload2 = !!el2.closest('[data-cart-reload]');
      if (q > 1)
        cartChange(Number(el2.getAttribute('data-line')), q - 1).then(function () {
          if (reload2) window.location.reload();
        });
    } else if (t('[data-cart-remove]')) {
      var el3 = t('[data-cart-remove]');
      var reload3 = !!el3.closest('[data-cart-reload]');
      cartChange(Number(el3.getAttribute('data-line')), 0).then(function () {
        if (reload3) window.location.reload();
      });
    }

    if (e.target.matches('[data-drawer-backdrop]')) {
      closeDrawer(e.target.closest('.vc-drawer-root'));
      VC.unlock();
    }
  });

  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var cart = document.getElementById('vc-cart');
      var menu = document.getElementById('vc-menu');
      if (cart && !cart.hidden) closeDrawer(cart);
      if (menu && !menu.hidden) closeDrawer(menu);
    }
  });

  /* ---------- boot ---------- */
  function boot() {
    initCountdowns();
    initPdp();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initCountdowns();
    initPdp();
  });
})();
